module.exports = __webpack_public_path__ + "static/git-rebase-v-merge-3-12bf4330519f29c3638ffac767b7bf01.png";